<template>
<div class="chapter">
<div class="inner_page">
<p class="imagep"><a id="page_9"><img alt="Images" height="192" src="images/f0009-01.jpg" width="300"/></a></p><a id="page_9">
</a><h2 class="h2"><a id="page_9"></a><a id="part01"><span class="txit">PART ONE</span></a></h2><a id="part01">
<h2 class="h2a">BEFORE MISTY</h2>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?33dcd0d8